<template>
    <EditSelect
        class="document-status-eip"
        :items="formattedSteps"
        :canEdit="canEdit"
        :showTag="true"
        @update="handleStatusUpdate"
    />
</template>
<script>
import EditSelect from 'vcomponents/common/editInPlace/Select/Select.vue';
import { allStatus, deliveryStatus } from 'Dictionaries/statusColors';

export default {
    components: {
        EditSelect,
    },
    props: {
        steps: {
            type: Array,
            required: true,
        },
        canEdit: {
            type: Boolean,
            default: true,
        },
        callback: {
            type: String,
            default: '',
        },
        isDelivery: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        formattedSteps() {
            if (this.steps.length === 0) {
                return [];
            }

            return this.steps.map((step) => ({
                id: step.id,
                label: step.label,
                color: this.isDelivery ? deliveryStatus[step.id].color : allStatus[step.id].color,
                icon: this.isDelivery ? deliveryStatus[step.id].icon : allStatus[step.id].icon,
                selected: step.selected,
                callback: step.callback,
            }));
        },
    },
    methods: {
        handleStatusUpdate(selectedItem) {
            const currentStep = this.formattedSteps.find((item) => item.selected);
            const selectedStep = this.formattedSteps.find((item) => item.id === selectedItem);

            if (selectedItem === currentStep?.id) {
                return;
            }

            let formattedCallback;

            if (selectedStep.callback) {
                formattedCallback = selectedStep.callback.replace(/@id/g, selectedItem);
            } else {
                formattedCallback = this.callback.replace(/@id/g, selectedItem);
            }

            eval(formattedCallback);
        },
    },
};
</script>
<style lang="scss" scoped>
::v-deep {
    &.document-status-eip {
        .compass-select {
            width: 100%;
        }
    }
}
</style>
